import { render, staticRenderFns } from "./wuju-share.vue?vue&type=template&id=8fdf2354&scoped=true&"
import script from "./wuju-share.vue?vue&type=script&lang=js&"
export * from "./wuju-share.vue?vue&type=script&lang=js&"
import style0 from "./wuju-share.vue?vue&type=style&index=0&id=8fdf2354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdf2354",
  null
  
)

export default component.exports